<template>
    <div v-if="asyncDataStatus_ready">

    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="saveOrder"
        >
          Shrani vrstni red
          <v-icon right dark>mdi-check</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({name: 'MyCompanyLevelsNew'})"
        >
          Nov nivo
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

 <v-col v-if="this.levels.length"  >
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Nivoji
                </th>

              </tr>
            </thead>
          </template>
        </v-simple-table>
      </v-col>
    <v-row v-if="this.levels.length" v-dragula="localLevels" drake="levels">

      <v-col
        v-for="item in localLevels"
        :key="item.id"
        :data-id="item.id"
        cols="12"
        class="pt-0 pb-0"
      >
        <TitleOnlyCard
          :style="{ 'border-left': `5px solid ${item.color}` }"
          :title="item.name"
          :draggable="true"
          @delete="showDeleteLevelModal = true; deleteLevel = item"
          @edit="$router.push({name: 'MyCompanyLevelsEdit', params: {id: item.id}})"
        />
      </v-col>
    </v-row>
    <v-row
      v-else
    >
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje novega nivoja uporabite gumb desno zgoraj.
        </p>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje nivoja"
      text="Ali ste prepričani, da želite izbrisati nivo? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteLevelModal"
      @confirmed="remove(deleteLevel)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { siIncludes } from '@/utils/str'
import { deleteItem } from '@/utils/crudFunctions'
import ConfirmDialog from '@/components/ConfirmDialog'
import TitleOnlyCard from '@/components/TitleOnlyCard'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    ConfirmDialog,
    TitleOnlyCard
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      filter: '',
      showDeleteLevelModal: false,
      deleteLevel: null,
      localLevels: []
    }
  },
  computed: {
    levels () {
      return objectToArray(this.$store.state.levels.items)
    },
    filteredLevels () {
      return this.levels.filter(item => siIncludes({ haystack: `${item.name}`, needle: this.filter }))
    }
  },
  methods: {
    ...mapActions('levels', ['loadItems', 'deleteItem']),
    ...mapActions('levels', { updateLevelsOrder: 'updateOrder' }),
    remove (item) {
      deleteItem(item, this)
    },
    saveOrder () {
      const updates = []
      this.localLevels.forEach((item, i) => {
        updates.push({
          id: item.id,
          sort_order: i + 1
        })
      })
      this.updateLevelsOrder(updates)
        .then(() => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
        })
    }
  },
  created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
    } else {
      this.loadItems()
        .then(levels => {
          this.localLevels = this.levels
          this.asyncDataStatus_fetched()
        })
    }
  },
  watch: {
    levels (newLevels) {
      this.localLevels = newLevels
    }
  }
}
</script>
